import React, {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'
import {KTIcon} from '../../../../../_metronic/helpers'

interface IPhotoUploadFieldProps {
  label: string
  file: File | null
  onFileSelect: (file: File) => void
  accept?: Record<string, string[]>
  required?: boolean
}

export default function PhotoUploadField({label, file, onFileSelect, accept, required}: IPhotoUploadFieldProps) {
  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      onFileSelect(acceptedFiles[0])
    }
  }, [onFileSelect])

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    accept: accept || {'image/*': ['.jpg', '.jpeg', '.png', '.webp']},
    maxFiles: 1,
  })

  return (
    <div>
      <label className='form-label fw-bold fs-6'>
        {label} {required && <span className='text-danger'>*</span>}
      </label>
      <div
        {...getRootProps()}
        className={`alert border border-dashed d-flex align-items-center p-5 mb-0 cursor-pointer ${
          isDragActive ? 'bg-light-success border-success' : file ? 'bg-light-primary border-primary' : 'bg-light border-secondary'
        }`}
      >
        <input {...getInputProps()} />
        <KTIcon iconName={file ? 'check-circle' : 'file-up'} className={`fs-2hx me-4 ${file ? 'text-success' : 'text-muted'}`} />
        <div className='d-flex flex-column'>
          <span className='fw-bold'>
            {file ? file.name : isDragActive ? 'Suelta el archivo aquí...' : 'Arrastra o haz clic para subir'}
          </span>
          {file && <span className='text-muted fs-7'>{(file.size / 1024).toFixed(1)} KB</span>}
        </div>
      </div>
    </div>
  )
}
